import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { CircleIcon, RelodeTheme } from "../..";
import * as domain from "../../domain";

const styles = (theme: RelodeTheme) =>
    createStyles({
        coverage: {
            fontSize: "0.55em",
            marginRight: theme.spacing(1),
            marginTop: theme.spacing(.33),
        },
        statusCancelled: {
            color: theme.relode.colors.interviewStatus.cancelled,
        },
        statusScheduled: {
            color: theme.relode.colors.interviewStatus.scheduled,
        },
        statusCompleted: {
            color: theme.relode.colors.interviewStatus.completed,
        },
        interviewStatus: {
            display: "flex",
            alignItems: "center",
        },
    });

interface Props extends WithStyles<typeof styles> {
    interviewStatusTypeId: number;
}

export const InterviewStatusDisplay = withStyles(styles)((props: Props) => {
    const { classes, interviewStatusTypeId } = props;

    return (
        <div className={classes.interviewStatus}>
            <CircleIcon
                className={classnames(
                    {
                        [classes.statusScheduled]:
                            interviewStatusTypeId ===
                            domain.InterviewStatusEnum.SCHEDULED.id,
                        [classes.statusCompleted]:
                            interviewStatusTypeId ===
                            domain.InterviewStatusEnum.COMPLETED.id,
                        [classes.statusCancelled]:
                            interviewStatusTypeId ===
                            domain.InterviewStatusEnum.CANCELED.id,
                    },
                    classes.coverage
                )}
            />
            {domain.InterviewStatusEnum.fromId(interviewStatusTypeId).label}
        </div>
    );
});
